import { render } from "./IconClose.vue?vue&type=template&id=558a6545"
const script = {}
script.render = render

export default script